var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#362FD8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18,
    fill: "#362FD8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_5935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 17C18 18.0609 18.4214 19.0783 19.1716 19.8284C19.9217 20.5786 20.9391 21 22 21C23.0609 21 24.0783 20.5786 24.8284 19.8284C25.5786 19.0783 26 18.0609 26 17C26 15.9391 25.5786 14.9217 24.8284 14.1716C24.0783 13.4214 23.0609 13 22 13C20.9391 13 19.9217 13.4214 19.1716 14.1716C18.4214 14.9217 18 15.9391 18 17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 31V29C16 27.9391 16.4214 26.9217 17.1716 26.1716C17.9217 25.4214 18.9391 25 20 25H23.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 32V32.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 28.9998C29.4483 28.9983 29.8832 28.8466 30.235 28.5687C30.5868 28.2909 30.8352 27.903 30.9406 27.4673C31.0459 27.0315 31.0019 26.5731 30.8158 26.1652C30.6297 25.7574 30.3122 25.4238 29.914 25.2178C29.5162 25.014 29.0611 24.9508 28.6228 25.0385C28.1845 25.1262 27.7888 25.3596 27.5 25.7008",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_5935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrders);
export default __webpack_public_path__ + "static/media/totalOrders.a4d4a975fbf13792189bf2f428f37a1d.svg";
export { ForwardRef as ReactComponent };